import { FieldName } from '../../types/CardFieldName';

export const validationErrorI18nKeys: Record<FieldName, string> = {
  [FieldName.Number]: 'card.number.error',
  [FieldName.CVV]: 'card.securityCode.error',
  [FieldName.ExpireDate]: 'card.expireDate.error',
  [FieldName.PostalCode]: 'card.postalCode.error',
  [FieldName.HolderName]: 'card.holderName.error',
};
